import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  email: '',
  nom: '',
  telephone: '',
  isAuthenticated: false
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUser: (state, action) => {
      state.email = action.payload.email || '';
      state.nom = action.payload.nom || '';
      state.telephone = action.payload.telephone || '';
      state.isAuthenticated = true;
    },
    updateUserEmail: (state, action) => {
      state.email = action.payload;
    },
    clearUser: (state) => {
      state.email = '';
      state.nom = '';
      state.telephone = '';
      state.isAuthenticated = false;
    }
  }
});

export const { setUser, updateUserEmail, clearUser } = userSlice.actions;
export default userSlice.reducer;
